<div class="item-container" [class]="class" [ngClass]="{'overlap': collapsable}" (click)="onClickComponent($event)">
  @if (srcIcon || iconName) {
    <div class="item-icon">
      <div class="icon-background" [ngClass]="color" [ngStyle]="{'background-color':color}">
        @if (srcIcon) {
          <img [src]="srcIcon" [alt]="itemText">
        }
        @if (!srcIcon && iconName) {
          <mat-icon
            [svgIcon]="iconName"
            [ngClass]="[iconName, color]"
            [ngStyle]="{'color': 'white'}">
          </mat-icon>
        }
      </div>
    </div>
  }
  <div class="item-text-container" [ngClass]="{'expanded': formGroup}" [ngClass]="{'full-width': !formGroup && !suffix}">
    <div class="item-text-content" [ngClass]="{'no-button': !displayTrashButton}">
      <h4 class="item-text">{{ itemText }}</h4>
      @if (itemSubtext) {
        <h4 class="item-subtext">{{ itemSubtext }}</h4>
      }
    </div>
    @if (displayTrashButton) {
      <button
        mat-icon-button
        class="trash-button"
        (click)="removeAction($event)">
        <mat-icon svgIcon="flat-trash-can" [class]="class"></mat-icon>
      </button>
    }
  </div>

  @if (formGroup) {
    <form [formGroup]="formGroup">
      <mat-checkbox #customCheckbox color="primary" [formControlName]="controlName"></mat-checkbox>
    </form>
  } @else {
    @if (suffix) {
      <div class="item-arrow">
        <mat-icon
          matIconSuffix
          svgIcon="arrow-right"
          [ngClass]="{'south': south, 'rotate': south && openCollapsable}"
          [ngStyle]="{'color': !south ? color : 'black'}">
        </mat-icon>
      </div>
    }
  }

</div>

<ng-container
  [ngTemplateOutletContext]="{ openCollapsable, data, index }"
  [ngTemplateOutlet]="itemDetailTemplate">
</ng-container>
